import { POLICY_CATEGORY_ESCALATION } from './policy-constants';

export const getSelectedCategoriesAfterConversationClose = (
  selectedCategories: string[],
): string[] =>
  selectedCategories.includes(POLICY_CATEGORY_ESCALATION) ? ['All'] : selectedCategories;

export interface ResolvePartnerIdInput {
  /** `undefined` means untouched; `null` means Global. */
  scopePartnerId?: number | null;
  siteAddressPartnerId?: number;
  conversationPartnerId?: number;
  fallbackPartnerId: number;
  isSitePartnerPending?: boolean;
}

/** An explicit scope pick outranks entity context; the caller drops the pick when the open entity changes. */
export const resolvePartnerId = ({
  scopePartnerId,
  siteAddressPartnerId,
  conversationPartnerId,
  fallbackPartnerId,
  isSitePartnerPending = false,
}: ResolvePartnerIdInput): number | undefined => {
  if (scopePartnerId !== undefined) {
    return scopePartnerId ?? fallbackPartnerId;
  }

  if (isSitePartnerPending) {
    return undefined;
  }

  // partnerId 0 is the platform partner, so these are undefined checks, not falsy ones
  if (siteAddressPartnerId !== undefined) {
    return siteAddressPartnerId;
  }
  if (conversationPartnerId !== undefined) {
    return conversationPartnerId;
  }

  return fallbackPartnerId;
};
